/**
 * Validates POST auth-service/v1/_whoami success payloads.
 * Rejects API error strings, Errors envelopes, and partial User / OAuth objects
 * so callers never hydrate session state from a half response.
 *
 * @param {*} res - Parsed JSON from httpRequest (or error placeholder)
 * @returns {boolean}
 */
export default function validateWhoAmiResponse(res) {
  if (res == null || typeof res !== "object" || Array.isArray(res)) return false;
  const errs = res.Errors;
  if (Array.isArray(errs) && errs.length > 0) return false;
  const user = res.User;
  if (!user || typeof user !== "object" || Array.isArray(user)) return false;
  const uuid = user.uuid;
  if (uuid == null || typeof uuid !== "string") return false;
  const trimmedUuid = String(uuid).trim();
  if (trimmedUuid === "" || trimmedUuid === "null") return false;
  const oauth = res.OAuthDetails;
  if (!oauth || typeof oauth !== "object") return false;
  const authToken = oauth.authToken;
  if (authToken == null || typeof authToken !== "string" || String(authToken).trim() === "") {
    return false;
  }
  return true;
}
